'use strict';

// jQuery is for monkeys.
// const $ = require('jquery');
// window.jQuery = $;
// window.$ = $;

// Lodash
import _ from 'lodash'
window._ = _
Vue.prototype._ = _

// Base
import Vue from 'vue'
import store from '@/store/panel.js'

// Routes file
import Routes from '@/routes/index.js'

// Vuelidate (frontend validation)
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

// Component file
import ThePanel from '@/vue/ThePanel'

// Axios
import axios from 'axios'
window.axios = axios
window.axios.defaults.headers['Accept'] = 'application/json' // Axios header default

// Import and setup Axios interceptors for handling 401 errors
import setupInterceptors from './axios-interceptor'
setupInterceptors()

// Momentjs
import moment from 'moment'
window.moment = moment
Vue.prototype.moment = moment
moment.locale('nl')

// FontAwesome
import { library } from '@fortawesome/fontawesome-svg-core'
// Solid
import { faExclamationTriangle, faSpinner, faCheck, faAngleLeft, faAngleRight, faAngleDown, faCalendarAlt, faArrowUp, faExclamationCircle, faChevronUp, faChevronDown, faEye, faEyeSlash, faUpload, faTrashAlt, faUserShield, faBuilding, faTachometerAlt, faBoxOpen, faFileAlt, faUserFriends, faFileInvoice, faSignOutAlt, faTimes, faBars, faFilePdf, faShieldAlt, faEuroSign, faPlus, faMinus, faExternalLinkAlt, faInfoCircle, faKey, faTimesCircle, faQuestionCircle, faCog, faPaperPlane, faTag, faSquare, faMap, faLock, faCheckCircle, faCopy, faRedo, faEdit, faPhone, faMobile, faPercent, faChartBar, faEnvelope } from '@fortawesome/free-solid-svg-icons'
// Regular
import { faClock } from '@fortawesome/free-regular-svg-icons'
// Add
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faExclamationTriangle, faSpinner, faCheck, faCalendarAlt, faAngleLeft, faAngleRight, faAngleDown, faArrowUp, faExclamationCircle, faChevronUp, faChevronDown, faEye, faEyeSlash, faUpload, faTrashAlt, faUserShield, faBuilding, faTachometerAlt, faBoxOpen, faFileAlt, faUserFriends, faFileInvoice, faSignOutAlt, faClock, faTimes, faBars, faFilePdf, faShieldAlt, faEuroSign, faPlus, faMinus, faExternalLinkAlt, faInfoCircle, faKey, faTimesCircle, faQuestionCircle, faCog, faPaperPlane, faTag, faSquare, faMap, faLock, faCheckCircle, faCopy, faRedo, faEdit, faPhone, faMobile, faPercent, faChartBar, faEnvelope)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// Global components
import FullPageLoader from '@/vue/FullPageLoader.vue'
Vue.component('FullPageLoader', FullPageLoader)
import InvoiceStatus from '@/vue/invoices/components/InvoiceStatus.vue'
Vue.component('InvoiceStatus', InvoiceStatus)
import SlideUpDown from 'vue-slide-up-down'
Vue.component('slide-up-down', SlideUpDown)
import PageTitle from '@/vue/PageTitle.vue'
Vue.component('PageTitle', PageTitle)

// Apex Charts - https://apexcharts.com/docs/vue-charts/
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

// Vue file agent (https://github.com/safrazik/vue-file-agent)
import VueFileAgent from 'vue-file-agent'
Vue.use(VueFileAgent)

const filter = function(text, length, clamp){
    clamp = clamp || '...';
    var node = document.createElement('div');
    node.innerHTML = text;
    var content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
};
Vue.filter('truncate', filter);

// Signature pad
import VueSignature from 'vue-signature-pad'
Vue.use(VueSignature)

// Buefy
import Buefy from 'buefy'
Vue.use(Buefy, {
    defaultIconComponent: 'font-awesome-icon',
    defaultIconPack: 'fa',
    // General
    defaultDialogConfirmText: 'Bevestigen',
    defaultDialogCancelText: 'Annuleren',
    defaultSnackbarPosition: 'is-top-right',
    // Dates
    defaultDayNames: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
    defaultMonthNames: ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'],
    defaultFirstDayOfWeek: 1,
    // defaultDateFormatter: date => date.toLocaleDateString('nl-NL')
})

// Vue Idle (https://www.npmjs.com/package/idle-vue)
import IdleVue from 'idle-vue';
Vue.use(IdleVue, {
    store,
    idleTime: 3600000, // 1 hour = 3600000(ms)
    startAtIdle: false,
    events: ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll', 'visibilitychange'] // Added visibilitychange event
})

// Laravel Echo / Pusher js
import Echo from 'laravel-echo'
window.Echo = Echo
require('pusher-js');

// Pusher local debug
// console.log('[🚀] Initializing pusher with ID:', 'd960e3a2f5e5aea49db0')
// window.Pusher = new Pusher('d960e3a2f5e5aea49db0', {
//     cluster: 'eu'
// })

document.addEventListener('DOMContentLoaded', () => {
    new Vue({
        el: '#app',
        router: Routes,
        render: h => h(ThePanel),
        store,

        created() {
            store.commit('setEnvironment', document.getElementById('app').getAttribute('environment'))
        }
    })
})

// [✅] Production settings.
if(process.env.NODE_ENV === 'production' && document.getElementById('app').getAttribute('environment') === 'production') {
    Vue.config.productionTip = false

    // Skip Pusher initialization if it fails to load or takes too long
    let timeoutId;
    const initPusher = new Promise((resolve, reject) => {
        try {
            console.log('[🚀] Attempting to initialize Pusher...')
            window.Pusher = new Pusher('70563d6661c838429560', {
                cluster: 'eu'
            })
            resolve()
        } catch (e) {
            reject(e)
        }
    })

    // Set timeout of 5 seconds
    const timeout = new Promise((resolve, reject) => {
        timeoutId = setTimeout(() => {
            reject(new Error('Pusher initialization timed out after 5 seconds'))
        }, 5000)
    })

    Promise.race([initPusher, timeout])
        .then(() => {
            clearTimeout(timeoutId) // Clear timeout on success
            console.log('[🚀] Pusher initialized successfully!')
        })
        .catch(e => {
            clearTimeout(timeoutId) // Clear timeout on failure
            console.warn('[⚠️] Failed to initialize Pusher, continuing without real-time updates:', e.message)
            window.Pusher = null
        })
} else if(process.env.NODE_ENV == 'production') {
    Vue.config.productionTip = false
    Vue.config.devtools = false
    Vue.config.debug = false
    Vue.config.silent = true
} else {
    console.log('[💡] Application is build for: ' + process.env.NODE_ENV)
}
